import { orchestrator } from "satcheljs";
import { TeamDataService } from "sh-services";
import { ITeamInfoEntity, ShiftStates, ShiftTypes } from "sh-models";
import ISmartScheduleShiftEntity, { WeekDays } from "sh-models/shift/ISmartScheduleShiftEntity";
import SmartScheduleShiftEntity from "sh-models/shift/SmartScheduleShiftEntity";
import { extendObservable } from "mobx";
import ShiftUtils from "sh-application/utility/ShiftUtils";
import setSmartScheduleShiftInStore from "../mutatorActions/setSmartScheduleShiftInStore";
import initializeLocalObservableSmartScheduleShift from "../actions/initializeLocalObservableSmartScheduleShift";
import ThemeUtils from "../../../../utility/ThemeUtils";

const DEFAULT_SMART_SCHEDULE_SHIFT_OPEN_SLOTS = 1;
const ALL_WEEKDAYS = [
    WeekDays.Monday,
    WeekDays.Tuesday,
    WeekDays.Wednesday,
    WeekDays.Thursday,
    WeekDays.Friday,
    WeekDays.Saturday,
    WeekDays.Sunday
];

/**
 * Initialize the local shift
 */
export const initializeObservableSmartScheduleShiftOrchestrator = orchestrator(initializeLocalObservableSmartScheduleShift, actionMessage => {
    const { shiftEditorViewState, shift, startDate } = actionMessage;
    const team: ITeamInfoEntity = TeamDataService.getCurrentTeam();
    const teamId = team ? team.id : "";
    const tenantId = team ? team.tenantId : "";
    let observableShift: ISmartScheduleShiftEntity = null;

    if (shift) {
        observableShift = SmartScheduleShiftEntity.clone(shift as ISmartScheduleShiftEntity);
        // Only set default times if the shift doesn't have valid times (e.g., when creating from a template)
        // For edit operations, preserve the existing start and end times
        if (!observableShift.startTime || !observableShift.endTime) {
            ShiftUtils.setDefaultShiftValuesForSmartSchedule(observableShift, startDate);
        }
    } else {
        observableShift = new SmartScheduleShiftEntity({
            id: null,
            eTag: null,
            tenantId: tenantId,
            teamId: teamId,
            memberId: null,
            shiftType: ShiftTypes.SmartSchedule,
            startTime: null,
            endTime: null,
            state: ShiftStates.Active,
            title: null,
            notes: null,
            theme: ThemeUtils.getDefaultShiftTheme(false),
            tagIds: [],
            subshifts: null,
            breaks: null,
            shiftRequestId: null,
            timeOffReasonId: null,
            isPublished: false,
            openSlots: DEFAULT_SMART_SCHEDULE_SHIFT_OPEN_SLOTS,
            repeatOn: ALL_WEEKDAYS
        });
        // For new shifts, always set default times
        ShiftUtils.setDefaultShiftValuesForSmartSchedule(observableShift, startDate);
    }

    setSmartScheduleShiftInStore(shiftEditorViewState, extendObservable(observableShift, {...observableShift}));
});